(function () {
  const page = document.querySelector(".sc-prey-gap-page");
  if (!page) return;

  const hideThemeChrome = () => {
    document.documentElement.classList.add("supercat-prey-gap-live");
    const headerGroup = document.getElementById("header-group");
    if (headerGroup) headerGroup.style.setProperty("display", "none", "important");
    Array.from(document.body.children).forEach((child) => {
      if (child.tagName === "FOOTER" && !child.closest(".sc-prey-gap-page")) {
        child.style.setProperty("display", "none", "important");
      }
    });
  };

  hideThemeChrome();
  document.addEventListener("DOMContentLoaded", hideThemeChrome);
  window.addEventListener("load", hideThemeChrome);

  const sizeHeroTestimonialImage = () => {
    const image = page.querySelector(".pg-hero-testimonial > img");
    if (!image) return;
    const size = window.matchMedia("(max-width: 720px)").matches ? 92 : 132;
    image.style.setProperty("width", `${size}px`, "important");
    image.style.setProperty("height", `${size}px`, "important");
    image.style.setProperty("min-height", `${size}px`, "important");
    image.style.setProperty("max-height", `${size}px`, "important");
  };

  sizeHeroTestimonialImage();
  window.addEventListener("load", sizeHeroTestimonialImage);
  window.addEventListener("resize", sizeHeroTestimonialImage);

  const replaceLegacyHeader = () => {
    const legacyHeader = page.querySelector(".pg-logo-header");
    if (!legacyHeader) return;

    const header = document.createElement("header");
    header.className = "sc-header";
    header.setAttribute("aria-label", "SuperCat page header");
    header.innerHTML = `
      <a class="brand" href="#top" aria-label="SuperCat Labs">
        <img class="brand-logo" src="https://cdn.shopify.com/s/files/1/0771/7601/2938/files/Untitled_design_-_2026-06-07T235126.142.png?v=1780891098&width=380" alt="SuperCat Labs" width="380" height="380" loading="eager">
      </a>
      <details class="sc-menu">
        <summary aria-label="Open page menu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </summary>
        <nav class="sc-menu-panel" aria-label="Page sections">
          <a href="#product-info">Product Info</a>
          <a href="#reviews">Reviews</a>
          <a href="#ingredients">Ingredients</a>
          <a href="#how-to-use">How to Use</a>
          <a href="#benefits">Benefits</a>
          <a href="#what-to-expect">What to Expect</a>
          <a href="#faqs">FAQ</a>
        </nav>
      </details>
    `;
    legacyHeader.replaceWith(header);
  };

  replaceLegacyHeader();

  const normalizeDosingTable = () => {
    const table = page.querySelector("#how-to-use .pg-comparison-table");
    if (!table) return;

    const firstHeader = table.querySelector("thead th:first-child");
    if (firstHeader && firstHeader.textContent.trim() === "Cat Weight") {
      firstHeader.textContent = "Weight";
    }

    const tableStyles = {
      display: "table",
      width: "100%",
      tableLayout: "fixed",
    };
    Object.entries(tableStyles).forEach(([property, value]) => {
      table.style.setProperty(property.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`), value, "important");
    });

    const groups = [
      ["thead", "table-header-group"],
      ["tbody", "table-row-group"],
      ["tr", "table-row"],
      ["th, td", "table-cell"],
    ];

    groups.forEach(([selector, display]) => {
      table.querySelectorAll(selector).forEach((node) => {
        node.style.setProperty("display", display, "important");
      });
    });

    table.querySelectorAll("th, td").forEach((cell) => {
      cell.style.setProperty("width", "50%", "important");
      cell.style.setProperty("vertical-align", "top", "important");
    });
  };

  normalizeDosingTable();
  document.addEventListener("DOMContentLoaded", normalizeDosingTable);
  window.addEventListener("load", normalizeDosingTable);
  window.addEventListener("resize", normalizeDosingTable);

  page.querySelectorAll(".pg-size-selector label, .pg-purchase-toggle label, .pg-package-card").forEach((card) => {
    card.addEventListener("click", () => {
      const group = card.closest(".pg-size-selector, .pg-purchase-toggle, .pg-package-list");
      const input = card.querySelector("input");
      if (group) {
        group.querySelectorAll(".is-selected").forEach((item) => item.classList.remove("is-selected"));
      }
      card.classList.add("is-selected");
      if (input) input.checked = true;
    });
  });

  page.querySelectorAll(".gallery-panel").forEach((gallery) => {
    const dots = Array.from(gallery.querySelectorAll(".dot"));
    const thumbs = Array.from(gallery.querySelectorAll(".slot-thumb[data-slide]"));
    const slides = Array.from(gallery.querySelectorAll(".gallery-slide"));
    const previousButton = gallery.querySelector(".gallery-prev");
    const nextButton = gallery.querySelector(".gallery-next");
    const stage = gallery.querySelector(".gallery-stage");
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("active")));
    let touchStartX = null;
    let touchStartY = null;

    const setActiveSlide = (index, scrollThumbnail = false) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle("active", slideIndex === activeIndex));
      dots.forEach((dot) => {
        const isActive = Number(dot.dataset.slide) === activeIndex;
        dot.classList.toggle("active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });
      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.slide) === activeIndex;
        thumb.classList.toggle("active", isActive);
        thumb.setAttribute("aria-current", isActive ? "true" : "false");
      });
      if (scrollThumbnail) {
        thumbs[activeIndex]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    };

    [...dots, ...thumbs].forEach((control) => {
      control.addEventListener("click", () => {
        const index = Number(control.dataset.slide);
        if (Number.isNaN(index)) return;
        setActiveSlide(index, true);
      });
    });

    previousButton?.addEventListener("click", () => setActiveSlide(activeIndex - 1, true));
    nextButton?.addEventListener("click", () => setActiveSlide(activeIndex + 1, true));
    stage?.addEventListener("touchstart", (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch?.clientX ?? null;
      touchStartY = touch?.clientY ?? null;
    }, { passive: true });
    stage?.addEventListener("touchend", (event) => {
      if (touchStartX === null || touchStartY === null) return;
      const touch = event.changedTouches[0];
      const deltaX = (touch?.clientX ?? touchStartX) - touchStartX;
      const deltaY = (touch?.clientY ?? touchStartY) - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      setActiveSlide(activeIndex + (deltaX < 0 ? 1 : -1), true);
    }, { passive: true });
    setActiveSlide(activeIndex);
  });

  const countdown = page.querySelector("[data-sc-sale-countdown]");
  if (countdown) {
    const duration = (6 * 60 * 60) + (23 * 60) + 40;
    let remaining = duration;
    const renderCountdown = () => {
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      countdown.textContent = [hours, minutes, seconds].map((part) => String(part).padStart(2, "0")).join(":");
      remaining = remaining > 0 ? remaining - 1 : duration;
    };
    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  }

  const viewerCount = page.querySelector("[data-sc-viewer-count]");
  if (viewerCount) {
    let currentViewers = 117;
    const fluctuateViewers = () => {
      currentViewers = Math.min(143, Math.max(96, currentViewers + Math.floor(Math.random() * 7) - 3));
      viewerCount.textContent = String(currentViewers);
      window.setTimeout(fluctuateViewers, 8000 + Math.random() * 7000);
    };
    window.setTimeout(fluctuateViewers, 9000);
  }

  const moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  const formatCents = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

  const setProperty = (form, key, value) => {
    const input = form.querySelector(`[data-sc-property="${key}"]`);
    if (input) input.value = value;
  };

  page.querySelectorAll(".pg-pdp-form").forEach((form) => {
    const updatePdpOffer = () => {
      const isSubscription = form.querySelector('input[name="properties[Purchase option]"]:checked')?.value !== "One-Time Purchase";
      const selectedCard = form.querySelector(".pg-package-card input:checked")?.closest(".pg-package-card");
      const sellingPlanInput = form.querySelector("[data-pg-selling-plan]");
      const submit = form.querySelector("[data-pg-submit]");

      form.querySelectorAll(".pg-package-card").forEach((card) => {
        const price = isSubscription ? card.dataset.pgSubscriptionPrice : card.dataset.pgOneTimePrice;
        const daily = isSubscription ? card.dataset.pgSubscriptionDaily : card.dataset.pgOneTimeDaily;
        const priceNode = card.querySelector("[data-pg-price]");
        const dailyNode = card.querySelector("[data-pg-daily]");
        if (priceNode) priceNode.textContent = formatCents(price);
        if (dailyNode) dailyNode.textContent = `${formatCents(daily)}/day`;
      });

      if (sellingPlanInput) {
        sellingPlanInput.disabled = !isSubscription;
        sellingPlanInput.value = isSubscription ? selectedCard?.dataset.pgPlanId || "" : "";
      }
      if (submit) {
        submit.textContent = isSubscription
          ? "Subscribe & Save — Up to 62% Off Regular Price"
          : "Add to Cart — One-Time Purchase";
      }
    };

    form.addEventListener("change", updatePdpOffer);
    form.addEventListener("click", (event) => {
      if (event.target.closest(".pg-package-card, .pg-purchase-toggle label")) window.setTimeout(updatePdpOffer, 0);
    });
    updatePdpOffer();
  });

  const selectedOfferCard = (form) => form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
  const selectedPurchaseType = (form) => form.querySelector('input[name="purchase_option"]:checked')?.value || "subscription";

  const updateOfferForm = (form) => {
    const card = selectedOfferCard(form);
    if (!card) return;

    const isSubscription = selectedPurchaseType(form) === "subscription";
    const sellingPlanInput = form.querySelector("[data-sc-selling-plan]");
    const currentPrice = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-price]");
    const currentCompare = form.closest(".shopify-product-box")?.querySelector("[data-sc-current-compare]");
    const submit = form.querySelector(".product-submit");
    const cardPrice = Number(isSubscription ? card.dataset.subscriptionPrice : card.dataset.oneTimePrice);
    const compareAt = Number(card.dataset.compareAt);
    const subcopy = isSubscription ? card.dataset.subscriptionSubcopy : card.dataset.oneTimeSubcopy;
    const purchaseLabel = isSubscription ? "Subscribe & Save" : "One-Time Purchase";
    const delivery = isSubscription ? card.dataset.delivery : "One-time purchase";

    form.querySelectorAll(".purchase-option").forEach((option) => {
      const input = option.querySelector('input[name="purchase_option"]');
      option.classList.toggle("selected", input?.checked);
    });

    form.querySelectorAll(".offer-card").forEach((item) => {
      const input = item.querySelector('input[name="id"]');
      item.classList.toggle("selected", item === card);
      if (input) input.checked = item === card;
      const itemPrice = Number(isSubscription ? item.dataset.subscriptionPrice : item.dataset.oneTimePrice);
      const itemCompare = Number(item.dataset.compareAt);
      const itemSubcopy = isSubscription ? item.dataset.subscriptionSubcopy : item.dataset.oneTimeSubcopy;
      const priceNode = item.querySelector("[data-sc-card-price]");
      const compareNode = item.querySelector("[data-sc-card-compare]");
      const subcopyNode = item.querySelector("[data-sc-card-subcopy]");
      const savingsNode = item.querySelector("[data-sc-card-savings]");
      const savingsCopyNode = item.querySelector("[data-sc-card-savings-copy]");
      const displayedSavingsRate = isSubscription
        ? item.dataset.subscriptionTotalSavingsRate
        : item.dataset.oneTimeSavingsRate;
      if (priceNode) priceNode.textContent = formatCents(itemPrice);
      if (compareNode) compareNode.textContent = formatCents(itemCompare);
      if (subcopyNode) subcopyNode.textContent = itemSubcopy || "";
      if (savingsNode) savingsNode.textContent = `${displayedSavingsRate || 0}% Off Regular Price`;
      if (savingsCopyNode) {
        savingsCopyNode.textContent = isSubscription
          ? `${item.dataset.subscriptionTotalSavingsRate || 0}% off regular price`
          : `Save ${item.dataset.oneTimeSavingsRate || 0}% today`;
      }
    });

    if (sellingPlanInput) {
      sellingPlanInput.disabled = !isSubscription;
      sellingPlanInput.value = isSubscription ? card.dataset.sellingPlanId || "" : "";
    }
    if (currentPrice) currentPrice.textContent = formatCents(cardPrice);
    if (currentCompare) currentCompare.textContent = formatCents(compareAt);
    if (submit && !submit.disabled) {
      submit.textContent = isSubscription
        ? "Subscribe & Save — Up to 62% Off Regular Price"
        : "Add To Cart - One-Time Purchase";
    }

    setProperty(form, "purchase_type", purchaseLabel);
    setProperty(form, "boxes", card.dataset.boxLabel || "");
    setProperty(form, "delivery", delivery);
    setProperty(form, "compare_at_unit", String(compareAt || cardPrice));
    setProperty(
      form,
      "savings_rate",
      isSubscription ? card.dataset.subscriptionTotalSavingsRate || "" : card.dataset.oneTimeSavingsRate || "",
    );
  };

  page.querySelectorAll(".shopify-product-form").forEach((form) => {
    const selectOfferCard = (card) => {
      if (!card) return;
      const input = card.querySelector('input[name="id"]');
      if (input && !input.disabled) input.checked = true;
      form.querySelectorAll(".offer-card").forEach((item) => item.classList.toggle("selected", item === card));
      updateOfferForm(form);
    };

    form.addEventListener("pointerdown", (event) => {
      const card = event.target.closest(".offer-card");
      if (card) selectOfferCard(card);
    }, true);

    form.addEventListener("change", (event) => {
      const purchaseInput = event.target.closest('input[name="purchase_option"]');
      const variantInput = event.target.closest('input[name="id"]');
      if (purchaseInput) {
        purchaseInput.closest(".purchase-toggle")?.querySelectorAll(".purchase-option").forEach((option) => {
          const input = option.querySelector('input[name="purchase_option"]');
          option.classList.toggle("selected", input?.checked);
        });
      }
      if (variantInput) {
        form.querySelectorAll(".offer-card").forEach((card) => card.classList.toggle("selected", card.contains(variantInput)));
      }
      updateOfferForm(form);
    });

    form.addEventListener("click", (event) => {
      const purchaseOption = event.target.closest(".purchase-option");
      if (purchaseOption) {
        const input = purchaseOption.querySelector('input[name="purchase_option"]');
        if (input) input.checked = true;
      }

      const card = event.target.closest(".offer-card");
      if (card) {
        selectOfferCard(card);
      }

      if (purchaseOption || card) updateOfferForm(form);
    });

    updateOfferForm(form);
  });

  page.querySelectorAll(".product-accordion-list").forEach((list) => {
    const accordions = Array.from(list.querySelectorAll(".product-accordion"));

    const setOpenAccordion = (selectedAccordion) => {
      accordions.forEach((item) => {
        item.open = item === selectedAccordion;
      });
    };

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector("summary");
      if (!summary) return;

      summary.addEventListener("click", (event) => {
        event.preventDefault();
        if (accordion.open) {
          accordion.open = false;
          return;
        }
        setOpenAccordion(accordion);
      });
    });
  });

  page.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = page.querySelector(link.getAttribute("href"));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      const menu = link.closest(".sc-menu");
      if (menu) menu.open = false;
    });
  });

  page.querySelectorAll(".sc-menu").forEach((menu) => {
    document.addEventListener("click", (event) => {
      if (!menu.contains(event.target)) menu.open = false;
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") menu.open = false;
    });
  });

  const galleryArrow = page.querySelector(".pg-gallery-arrow");
  const heroLockup = page.querySelector(".pg-product-lockup");
  let galleryIndex = 1;
  if (galleryArrow && heroLockup) {
    galleryArrow.addEventListener("click", () => {
      galleryIndex = galleryIndex === 1 ? 2 : 1;
      heroLockup.dataset.imageRequest = galleryIndex === 1 ? "image-01" : "image-24";
      heroLockup.querySelector("span").textContent =
        galleryIndex === 1 ? "Image 01 · product offer hero · 695x695" : "Image 24 · alternate offer visual · 695x695";
    });
  }

  const stickyCta = page.querySelector(".pg-sticky-cta");
  const stickyTarget = stickyCta ? page.querySelector(stickyCta.getAttribute("href")) : null;
  const updateStickyCta = () => {
    if (!stickyCta) return;
    const targetRect = stickyTarget ? stickyTarget.getBoundingClientRect() : null;
    const targetIsVisible = targetRect ? targetRect.top < window.innerHeight && targetRect.bottom > 0 : false;
    document.body.classList.toggle("show-pg-sticky", window.scrollY > 900 && !targetIsVisible);
  };

  window.addEventListener("scroll", updateStickyCta, { passive: true });
  window.addEventListener("resize", updateStickyCta);
  updateStickyCta();
})();
const refreshSubscriptionGroupLabels = () => {
  document.querySelectorAll('input[data-radio-type="selling_plan_group"]').forEach((input) => {
    const label = input.closest('label');
    if (!label) return;
    label.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Subscribe & Save 15%')) {
        node.textContent = node.textContent.replace('Subscribe & Save 15%', 'Subscribe & Save — Up to 62% off regular price');
      }
    });
  });
};

refreshSubscriptionGroupLabels();
new MutationObserver(refreshSubscriptionGroupLabels).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
